import React from 'react'
import { Link } from "react-router-dom";


export default function EmailTemplateCommon() {

  var pathname = window.location.pathname;
  var pathnamesplits = pathname.split("/");
  var url = pathnamesplits[4];

  return (
    <ul className="nav nav-tabs nav-line-tabs mb-5 fs-6">
      <li className="nav-item">
        <Link
          to={{
            pathname:
              "/group_admin/settings/emailtemplate/emailtemplatelist",
          }}
          className={
            url === "emailtemplatelist"
              ? "nav-link active"
              : "nav-link"
          }
        >
         Email Template
        </Link>
      </li>
      <li className="nav-item">
        <Link
          to={{
            pathname:
              "/group_admin/settings/emailtemplate/emailsetup",
          }}
          className={
            url === "emailsetup"
              ? "nav-link active"
              : "nav-link"
          }
        >
          Email Setup
        </Link>
      </li>
    </ul>
  )
}
